export default __webpack_public_path__ + "static/media/clouds.6fc2e45c.svg";